import React, { useState } from 'react'
import { getImages } from '../Components/const'
import ModalLayout from '../Components/Common/ModalLayout';
import OrderPartsModal from '../Components/OrderParts/OrderPartsModal';
import UseScrollReveal from '../Components/Common/UseScrollReveal ';
import SeoMeta from '../Components/Common/SeoMeta';

const OrderParts = () => {
    const [orderPartsModal, setOrderPartsModal] = useState(false);
    const chandleOrderPartsModal = () => {
        setOrderPartsModal(true)
    }
    const closeOrderPartsModal = () => {
        setOrderPartsModal(false)
    }
    UseScrollReveal()
    return (
        <>
            <SeoMeta
                title="Order Parts | Official McLaren Dealer in Orlando, FL | McLaren Orlando"
                description="McLaren Orlando is committed to providing exceptional customer service for our clients. Our Service Center utilizes only genuine McLaren parts when servicing or repairing your car."
                keywords=""
                ogTitle="Order Parts | Official McLaren Dealer in Orlando, FL | McLaren Orlando"
                ogDescription="McLaren Orlando is committed to providing exceptional customer service for our clients. Our Service Center utilizes only genuine McLaren parts when servicing or repairing your car."
            />
            <section className='common-banner-wrap'>
                <img src={getImages('order-parts-bg.webp')} alt='order parts' />
                <div className='common-banner-pos pt-140'>
                    <div className='container'>
                        <div className='d-flex align-items-center'>
                            <div className='w-100'>
                                <h4 className='xs-title text-uppercase font-1-1em fw-300 text-lgray wow reveal fadeIn'>McLaren Orlando</h4>
                                <h1 className='lg-title text-uppercase mt-2 wow reveal fadeIn'>Order Parts</h1>
                                <div className='mt-4 wow reveal fadeIn'>
                                    <button type='button' onClick={chandleOrderPartsModal} className='theme-btn text-uppercase d-inline-block'>Place Order</button>
                                </div>
                                <div className='mt-4 wow reveal fadeIn'>
                                    <a type='button' href="mailto:parts@mclarencf.com" className='theme-btn text-uppercase d-inline-block'>Email Parts</a>
                                </div>
                                <div className='mt-4 wow reveal fadeIn'>
                                    <h4 className='xs-title text-uppercase font-1-1em fw-300 text-lgray wow reveal fadeIn'>parts@mclarencf.com</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='common-wrap'>
                <div className='container'>
                    <h2 className='lg-title fw-300 text-gray text-uppercase mb-2 wow reveal fadeInUp'>YOUR TRUSTED SOURCE FOR MCLAREN OEM PARTS IN <br/>CENTRAL FLORIDA</h2>

                    <div className='oem-block mt-4 d-flex align-items-center'>
                        <div className='w-50 order-2'>
                            <img className='w-100' src={getImages('oem-parts-image.webp')} alt='OEM Parts' />
                        </div>
                        <div className='w-50'>
                            <div className='mxw-530 mx-auto'>
                                <div className='xs-title font-1-2em mb-4 text-white wow reveal fadeInUp'>Thanks for trusting McLaren Orlando for your OEM parts! As the leading provider of certified original equipment manufacturer (OEM) parts for McLaren in Orlando, Central Florida, and beyond, we have everything required to complete your repair or service properly and efficiently.</div>
                                <div className='mt-5 wow reveal fadeInUp'>
                                    <button type='button' onClick={chandleOrderPartsModal} className='sub-sm-btn d-inline-block w-50 text-uppercase'>Place Order</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mt-5'>
                        <h2 className='xs-title font-1-9em text-orange text-uppercase mb-2 wow reveal fadeInUp'>Why OEM</h2>
                        <div className='common-text'>
                            <p>There are multiple reasons to purchase OEM parts rather than Aftermarket parts for your McLaren.
    Firstly, OEM parts are designed by McLaren specifically for your McLaren vehicle. The same engineers and developers that collaborate to design every inch of your vehicle work together to create these parts so that they work in perfect harmony with the way your McLaren is meant to look, drive, and perform.</p>

                            <p>McLaren parts are built, tested, and inspected according to McLaren’s rigorous standards. This assures you that the same quality and performance put into your McLaren is carried forward into the parts you are replacing or adding.</p>

                            <p>Last, but not least, your McLaren parts are backed by factory warranty. These certified parts safeguard you and your vehicle to provide you with even more peace of mind and support.</p>

                            <p>Our trained and trustworthy McLaren Parts team is here for you, which means you have expert guidance on finding and fitting the correct part for your vehicle and needs, as well as personal attention and care along the way. Contact McLaren Orlando today to inquire about OEM parts for your McLaren and invest in the future of your vehicle so you can enjoy it for years to come.</p>
                        </div>
                    </div>
                </div>
            </section>
            
            <ModalLayout open={orderPartsModal} close={closeOrderPartsModal} darkThemeCls='true' modalWidth={1040}>
                <OrderPartsModal close={closeOrderPartsModal}/>
            </ModalLayout>
        </>
    )
}

export default OrderParts